import { render, staticRenderFns } from "./cadastro-projeto.html?vue&type=template&id=50bf4295&scoped=true&"
import script from "./cadastro-projeto.js?vue&type=script&lang=js&"
export * from "./cadastro-projeto.js?vue&type=script&lang=js&"
import style0 from "./cadastro-projeto.css?vue&type=style&index=0&id=50bf4295&scoped=true&lang=css&"
import style1 from "@/assets/css/input.css?vue&type=style&index=1&id=50bf4295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bf4295",
  null
  
)

export default component.exports